import React from 'react';
import { Redux, Slices } from 'spwa-ui-library';

import DrawerPwa from '../DrawerPwa';
import DialogBox from '../DialogBox';
const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;

const DialogWrapper = ({ children, isOpen, onClose }) => {
  const isDesktop = useSelector(selectDesktop);
  if (isDesktop) {
    return (
      <DialogBox title="" size="sm" isOpen={isOpen} onClose={onClose} page="login">
        {children}
      </DialogBox>
    );
  } else {
    return (
      <DrawerPwa variant="temporary" anchor="bottom" open={isOpen} onClose={onClose}>
        {children}
      </DrawerPwa>
    );
  }
};

export default DialogWrapper;
